import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import { Link, useParams, useNavigate } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar'
import InfiniteScroll from "react-infinite-scroller";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { Markup } from 'interweave';

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import styles from '../../App.module.css'
import classes from './Activity.module.css'
import Footer from '../Footer/Footer';
import Spinner from '../Global/Spinner';
import EmptyContent from '../Global/EmptyContent';

import noThumb from "../../images/no-thumb.jpg";

function Activity() {
    const navigate = useNavigate();
    const { type } = useParams();
    const [title, setTitle] = useState('');
    const [videos, setVideos] = useState([]);
    const [hasMore, sethasMore] = useState(false);
    const [page, setpage] = useState(2);
    const [progress, setProgress] = useState(10);
    const [loading, setLoading] = useState(false);
    const [pageTitle, setPageTitle] = useState('Activity');
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
      !logged_user && navigate('/login');

      type === 'history' && setPageTitle('Watch History');
      type === 'likedvideos' && setPageTitle('Liked Videos');
      type === 'watchlater' && setPageTitle('Watch Later');
    }, []);

    const fetchData = () => {
      setLoading(false);
      setVideos([]);

      axios.post(`${process.env.REACT_APP_API_URL}/api/user/activity.php`, {
          user_id: logged_user,
          type: type,
          limit: 10
        }, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }).then(response => {
          // console.log(response.data);
          setVideos(response.data);
          response.data.length < 10 ? sethasMore(false) : sethasMore(true);
          
          setLoading(true);
          setProgress(100);
        })
    }

    const loadMore = () => {
      axios.post(`${process.env.REACT_APP_API_URL}/api/user/activity.php`, {
          user_id: logged_user,
          type: type,
          page: page,
          limit: 10
        }, {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }).then(response => {
          if(response.data.message !== 'No activity found') {
            loading && hasMore && setVideos([...videos, ...response.data]);
            setpage(page + 1);
    
            response.data.length < 10 ? sethasMore(false) : sethasMore(true);
          }else {
            sethasMore(false);
          }
        })
    }

    useEffect(() => {
      setVideos([]);
      if(type === 'history') {
        setTitle('Watch History')
      }else if(type === 'likedvideos') {
        setTitle('Liked Videos')
      }else if(type === 'watchlater') {
        setTitle('Watch Later')
      }else {
        navigate("/404");
      }

      fetchData();
    }, [type]);

  return (
    <>
      <Helmet>
          <title>{pageTitle} - Wesharez</title>
          <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
          <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <div className={classes.activity_component + ' p-4'}>
              <div className={classes.sec_name}>
                  <h3>{title}</h3>
              </div>
              <div className="">
                {
                  videos && videos.map ? <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMore}
                    hasMore={hasMore}
                    loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                    className='row'
                  >
                    {
                      videos && videos.map && videos.map((video, index) => {
                        let thumb = null;
                        if(video.thumb.includes('storage/media/thumbs/')) {
                            thumb = `${process.env.REACT_APP_API_URL}/${video.thumb}`;
                        }else {
                            thumb = video.thumb;
                        }

                        return (
                          <div className={classes.video + ` row`} key={index}>
                              <div className="col-lg-3 col-sm-5 col-xs-6">
                                  <div className={classes.thumb}>
                                      <Link to={`/video/${video.id}/${video.nice_url}`}>
                                          <img src={thumb} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                      </Link>
                                      {
                                          (video.duration > 0) && <div className={classes.duration}>{video.video_time}</div>
                                      }
                                  </div>
                              </div>
                              <div className="col-lg-9 col-sm-7 col-xs-6">
                                  <div className={classes.title}>
                                      <Link to={`/video/${video.id}/${video.nice_url}`}><Markup content={video.title}></Markup></Link>
                                  </div>
                                  <div className={classes.uploaderlink}><Link to={`/profile/${video.user_id}/${video.username}`}>{video.owner}</Link></div>
                                  <div className={classes.views}>{video.views} views</div>
                              </div>
                          </div>
                        )
                      })
                    }
                  </InfiniteScroll>
                  : <EmptyContent />
                }
              </div>
            </div>
            <Footer />
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default Activity